/**
 * Redux reducer for auth.
 * @module redux/reducers/auth
 */

import update from 'immutability-helper';
import {
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  RECEIVED_AXIS_USER_PROFILE,
  REQUEST_AXIS_USER_PROFILE,
  REQUEST_AXIS_USER_PROFILE_FAILED
} from './../actions/auth';

const initialState = {
  user: {
    userId: -1,
    username: null,
    loggedIntoAxis: false,
    sessionId: null
  },
  authenticated: false,
  isLoggingIn: false,
  axisUserProfile: {
    projects: [],
    services: [],
    canCreateOrders: false,
    hasAccessToApGraphics: false,
    hasAccessToMgnGraphics: false,
    loaded: false,
    loading: false
  }
};

const ACTION_HANDLERS = {
  [LOGIN_SUCCESS]: (state, action) => ({
    ...state,
    user: action.payload.user,
    isLoggingIn: false,
    authenticated: true,
  }),
  [LOGIN_FAILURE]: () => (initialState),
  [LOGIN_REQUEST]: (state) => ({
    ...state,
    isLoggingIn: true
  }),
  [RECEIVED_AXIS_USER_PROFILE]: (state, action) => update(state, {
    axisUserProfile: {
      projects: { $set: action.payload.projects },
      services: { $set: action.payload.services },
      canCreateOrders: { $set: action.payload.canCreateOrders === 'True' },
      hasAccessToApGraphics: { $set: action.payload.hasAccessToApGraphics === 'True' },
      hasAccessToMgnGraphics: { $set: action.payload.hasAccessToMgnGraphics === 'True' },
      loaded: { $set: true },
      loading: { $set: false }
    }
  }),
  [REQUEST_AXIS_USER_PROFILE]: (state) => update(state, {
    axisUserProfile: {
      loading: { $set: false }
    }
  }),
  [REQUEST_AXIS_USER_PROFILE_FAILED]: (state) => update(state, {
    axisUserProfile: {
      loaded: { $set: true },
      loading: { $set: false }
    }
  })
};

export default function auth(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./app/reducers/auth.js